import { Helmet } from 'react-helmet-async';
import { FileManager } from '@/components/file-manager';

interface FilesProps {
  isGlobalDarkMode?: boolean;
}

export default function Files({ isGlobalDarkMode = true }: FilesProps) {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Files | AgencyPlus</title>
        <link rel="canonical" href="/files" />
      </Helmet>

      <main className="w-full p-0">
        <FileManager isGlobalDarkMode={isGlobalDarkMode} />
      </main>
    </div>
  );
}
